import React, { useState } from "react";
import Error from "./Error";

const Formulario = ({ setSearch }) => {
  const [palabra, setPalabra] = useState("");
  const [error, setError] = useState(false);

  const buscarImagenes = (e) => {
    e.preventDefault();

    //Validar
    if (palabra.trim() === "") {
      setError(true);
      return;
    }
    setError(false);

    //Enviar a app
    setSearch(palabra);
  };

  return (
    <form onSubmit={buscarImagenes}>
      <div className="row">
        <div className="form-group col-md-8">
          <input
            type="text"
            placeholder="Busca una imágen"
            className="form-control form-control-lg"
            onChange={(e) => setPalabra(e.target.value)}
          />
        </div>
        <div className="form-group col-md-4">
          <input
            type="submit"
            className="btn btn-lg btn-danger btn-block"
            value="Buscar"
          />
        </div>
      </div>
      {error ? <Error mensaje="Agrega un termino para la busqueda" /> : null}
    </form>
  );
};

export default Formulario;
